//from Node
require('bootstrap-datepicker');

//from local
require('./functions');
require('./radio');
require('./base');
require('./map');
require('./cookie-banner');